var _a;
import { createSlice } from "@reduxjs/toolkit";
export var userSliceInitialState = {
    metadata: null,
    lastFetched: 0,
};
var userSlice = createSlice({
    name: "user",
    initialState: userSliceInitialState,
    reducers: {
        setUserMetadata: function (state, action) {
            state.metadata = action.payload;
            state.lastFetched = Date.now();
        },
        clearState: function (state) {
            state.metadata = null;
            state.lastFetched = 0;
        },
    },
});
export var selectUser = {
    userMetaData: function (state) { return state.user.metadata; },
    lastFetched: function (state) { return state.user.lastFetched; },
};
export var clearState = (_a = userSlice.actions, _a.clearState), setUserMetadata = _a.setUserMetadata;
export var userReducer = userSlice.reducer;
